import React,{useContext,useState,useEffect} from "react";
import {Box,Typography,Menu, MenuItem,Button} from '@mui/material';
import "../../cssfiles/homepage.css";
import { ThemeContext } from "../Homepage";
import { useSelector } from "react-redux";
import LK_Add from "../../images/LK_Add";
import LK_Delete from '../../images/LK_Delete';
import CustomButton from "../CommonComponents/CustomButton";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomCheckbox from "../CommonComponents/CustomCheckbox";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import CustomMultiselectWithCheckbox from "../CommonComponents/CustomMultiselectWithCheckbox";
import CustomSelectedOptions from "../CommonComponents/CustomSelectedOptions";
import LK_Select from '../../images/LK_Select';
import LK_Close from '../../images/LK_Close';
import LK_Search from '../../images/LK_Search';
import {assetcreate ,assetdelete, getassets1 ,getdevicelist} from "../../Restclient/datacollection";
import MoreVertIcon from '@mui/icons-material/MoreVert';



export default function Assets() {

    const [openForm, setOpenForm] = React.useState(0);
    const [ifsearching, setifSearching] = useState(0);
    const [search, setSearch] = useState({searchText:"",filterSelected:""});
    const [assetno, setAssetno] = useState([]);
    const [assetInfo, setAssetInfo] = useState({organizationId:"",projectId:"",id:"",data:{assetName:"",serialNo:"",description:"",/*commissionDate:"",decommissionDate:"",*/associatedDevices:[]}});
    const [deleteAsset,setDeleteAsset] = React.useState(false);
    const [searchList,setsearchList] = React.useState([]);
    const [deleteAssetArr,setDeleteAssetArr] = React.useState([]);
    const{ theme }= useContext(ThemeContext);
    const [required, setRequired] = React.useState(0);
    const [saveStatus, setSaveStatus] =  React.useState(0);
    const filter = ["Asset Name","Asset ID","Device Name","Serial No.",];    
    const userdetails = useSelector(state => state.logindata.userdetails);
    const [devicelist,setDevicelist]=useState([]);
    const [deviceidlist,setDeviceidlist]=useState([]);


    useEffect(()=>{
        getassets1(getassetscallback);
        getdevicelist(getdevicelistcallback);
    },[])

    function getdevicelistcallback(res){
        let data=[];
        res.map((_val,index)=>{
            data=[...data,res[index].Name]
        })
        setDeviceidlist(res)
        setDevicelist(data)
    }

    function getassetscallback(res){
        let temp=[];
        let data;
        res.map((_val,index)=>{
            data = {organizationId:res[index].OrgID,projectId:res[index].ProjectID,id:res[index].AssetID,data:{assetName:res[index].Name,serialNo:res[index].SN,description:res[index].Description,/*commissionDate:res[index].commissionDate,decommissionDate:res[index].decommissionDate,*/associatedDevices:res[index].DeviceID}}
            temp=[...temp,data]
            
        });
        setAssetno(temp)
        // let data = allassets(res);
        // /dispatch(getassetno(data));
    }


    // useEffect(()=>{
    // },[assetInfo.data.associatedDevices])

    const handleCloseAddForm = () => {
        setOpenForm(0);
        setRequired(0);
        setSaveStatus(0);
        setAssetInfo({organizationId:"",projectId:"",id:"",data:{assetName:"",serialNo:"",description:"",/*commissionDate:"",decommissionDate:"",*/associatedDevices:[]}})
    }

    const handleSaveAddForm = () => { 
        if(assetInfo.data.deviceName!=="" && assetInfo.data.serialNo!==""/* && assetInfo.data.deviceType!=="" && assetInfo.data.commissionDate!=="" && assetInfo.data.decommissionDate!==""*/)
            {
                    if(assetInfo.data.associatedDevices.length===0){
                        assetInfo.data.associatedDevices=[]
                    }
                    assetcreate(assetInfo,callback);
                
                setRequired(0);
            }
            else{
                setOpenForm(1);
                setRequired(1);
            }
    }

    function callback(res){
        if(res.status===201)
        {
            if(assetInfo.id===""){
                assetInfo.id=res.data.deviceId;
                setAssetno([...assetno,assetInfo])
            }
            else{
                let assetindex =0;
                assetno.map((val,index)=>{
                    val.id=assetInfo.id;
                    assetindex = index;
                })
                assetno.splice(assetindex,1,assetInfo);
                setAssetno([...assetno])
                //sjjkk last element as this is in greation 
                // assetno[assetno.length - 1].data.deviceName=assetInfo.data.deviceName;
                // assetno[assetno.length - 1].data.serialNo=assetInfo.data.serialNo;
                // assetno[assetno.length - 1].data.enable=assetInfo.data.enable;
                // assetno[assetno.length - 1].data.connectionState=assetInfo.data.enable;
                // assetno[assetno.length - 1].data.associatedGateway=assetInfo.data.associatedGateway;
            }
            setSaveStatus(1);
        }
        else
        {
            setSaveStatus(2);
            //
        }
          

    };

    function handleAssetName(selectedValue){
        assetInfo.data.assetName=selectedValue;
        setAssetInfo(assetInfo);
    };

    function handleAssetSerialNo(selectedValue){
        assetInfo.data.serialNo=selectedValue;
        setAssetInfo(assetInfo);
    };

    function handleAssetDescription(selectedValue){
        assetInfo.data.description=selectedValue;
        setAssetInfo(assetInfo);
    };


    function handleDeleteCancel(){
        // deleteGatewayArr.map((val)=>(
        //     gatewayno.filter((value)=>value!=val)
        // ))
        setDeleteAssetArr([]);
        setDeleteAsset(0);
        //gatewaydelete(deleteGatewayArr,deletioncallback)
        
    }

    function handleDeleteSelected(){
        // deleteAssetArr.map((val)=>(
        //     gatewayno.filter((value)=>value!=val)
        // ))
        assetdelete(deleteAssetArr,deletioncallback)
        
    }


    function deletioncallback(res,_id,){
        if(res.status===200){
            let temp=[];
            let data;
            res.data.assets.map((val,_index)=>{
                // data = {organizationId:val.Organizationid,projectId:val.Projectid,id:val.deviceId,data:{assetName:val.assetName,serialNo:val.serialNo,description:val.description,/*commissionDate:val.commissionDate,decommissionDate:val.decommissionDate,*/associatedDevices:val.associatedDevices}}
                data = {organizationId:val.OrgID,projectId:val.ProjectID,id:val.AssetID,data:{assetName:val.Name,serialNo:val.SN,description:val.Description,/*commissionDate:val.commissionDate,decommissionDate:val.decommissionDate,*/associatedDevices:val.DeviceID}}
                temp=[...temp,data]
                
            });
            setAssetno(temp)
            setDeleteAssetArr([]);
            setDeleteAsset(false);
        }
        else{
        }   
    }


    function handleFilterSelected(selectedValue){
        search.filterSelected=selectedValue;
        setSearch(search);
    };

    function handleSearchText(selectedValue){
        search.searchText=selectedValue;
        setSearch(search);
    };

    function handleSearchCancel(){
        setSearch({searchText:"",filterSelected:""});
        setsearchList([]);
        setifSearching(0);
    };

    function handleSearchClick(){
        setifSearching(1);
        let temp = [];
            assetno.filter(value=>{
                let deviceassociated = false;
                value.data.associatedDevices.map(val=>{if(val.includes(search.searchText)){deviceassociated = true}})
                if(value.data.assetName.includes(search.searchText) || value.id.includes(search.searchText) || value.data.serialNo.includes(search.searchText) || value.data.description.includes(search.searchText) ||  deviceassociated===true){
                    temp=[...temp,value];
                }
            })
        setsearchList(temp);
    };

    

    const AssetForm = props => {
        const [plantHierarchy,setPlantHierarchy]=React.useState(0); 
        const [assetDetails,setAssetDetails]=React.useState(1);
        const [associatedDeviceDetails,setAssociatedDeviceDetails]=React.useState(1);
        let temp=[];
        props.assetData.data.associatedDevices.map( value =>{
            deviceidlist.map(val => {
                if(val.DeviceID===value){
                    temp=[...temp,val.Name]
                }
            })
        });
        const [associatedDevicesList,setAssociatedDevicesList] = React.useState(temp);

        function handleSelectedOption(selected){
            // selected.map((value)=>{

            // })
            let temp=[];
            selected.map((val,_index)=>(
                deviceidlist.map(value=>{
                    if(value.Name===val){
                    temp=[...temp,value.DeviceID]
                }})
            ))
            assetInfo.data.associatedDevices=[...temp]
            temp=[...selected]
            setAssociatedDevicesList(temp)
            setAssetInfo(assetInfo);
        }
    
        function handleRemoveOption(selectedValue){
            const temp1 =assetInfo.data.associatedDevices.filter((_value,index) => index !== selectedValue);
            assetInfo.data.associatedDevices=[...temp1]
            setAssociatedDevicesList(temp1)
            setAssetInfo(assetInfo);
        }


        return(
            <Box sx={{width:'100%',height:'100%'}}>
                <Box sx={{width:'100%',height:'7%',display:"flex",flexDirection:'row',alignItems:'center',gap:'8px'}}>
                    <Typography style={{ fontSize: '24px', fontWeight: 700, color: "#008CD7"  }}>{props.assetData.id!==""?props.assetData.data.assetName:"Assets"}</Typography>
                    {/* <Box sx={{flexGrow:1}}></Box>
                    {required===1?<><Typography sx={{color:"#DC272D"}}>required fields to must be filled</Typography></>:<></>}
                    {saveStatus!==0?
                        <>
                            <Typography sx={{color: saveStatus===1? theme==='dark'?'#C1C1C1':'#3C3C3C':"#DC272D"}}>{saveStatus===1?"Saved Successfully!":"Save Failed"}</Typography>
                        </>
                        :
                        <></>
                    }
                    <CustomCancelButton onClick={props.closeForm} children={'Cancel'}></CustomCancelButton>
                    {/* <Button id={props.index} onClick={props.saveForm}>Save</Button> *}
                    <CustomButton id={props.index} onClick={props.saveForm} children={'Save'} width={'12px'} /> */}
                </Box>
                <Box sx={{width:'100%',height:'93%',overflow:'auto'}}>
                    <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "#008CD7",padding:"4px",marginTop:"20px" ,/*backgroundColor:theme==='dark'?'#3C3C3C40':'#FFFFFF80'*/}}>Asset Details <Button onClick={()=>{(assetDetails===1)?setAssetDetails(0):setAssetDetails(1)}}>{(assetDetails===1)?<ExpandLessOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}} /> : <ExpandMoreOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}}/>}</Button></Typography>
                    {assetDetails===1?
                        <Box  style={{overflow:"auto"}} sx={{display:"flex",gap:'0px',flexWrap:'wrap',padding:"4px 4px 12px 4px",backgroundColor:theme==='dark'?'#3C3C3C40':'#FFFFFF80'}}>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}} >
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Asset Name<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                <CustomTextField id={'negative-feedback'} onChange={handleAssetName} disabled={props.assetData.id!==""?true:false} defaultValue={props.assetData.id!==""?(props.assetData.data.assetName):assetInfo.data.assetName} maxLength={16} width={224}/> 
                            </Box>
                            {props.assetData.id!==""?
                                <>
                                    <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                        <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Asset ID</Typography>
                                        <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>{props.assetData.id}</Typography>
                                    </Box>
                                </>
                                :
                                <></>
                            }
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"33.33%",boxSizing:'border-box',marginTop:"12px"}}>
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Asset Serial No.<span style={{ color: "red", marginLeft: "5px" }}>*</span></Typography>
                                <CustomTextField id={'negative-feedback'} onChange={handleAssetSerialNo} disabled={props.assetData.id!==""?true:false} defaultValue={props.assetData.id!==""?(props.assetData.data.serialNo):assetInfo.data.serialNo} maxLength={16} width={224}/> 
                            </Box>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"66.66%",boxSizing:'border-box',marginTop:"12px"}}>
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Asset Description</Typography>
                                <CustomTextField id={'negative-feedback'} onChange={handleAssetDescription}  defaultValue={props.assetData.id!==""?props.assetData.data.description:assetInfo.data.description} maxLength={250} width={757}/> 
                            </Box>
                        </Box>
                        :
                        <></>
                    }
                    <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "#008CD7",padding:"4px",marginTop:"20px" }}>Associated Devices Details<Button onClick={()=>{(associatedDeviceDetails===1)?setAssociatedDeviceDetails(0):setAssociatedDeviceDetails(1)}}>{(associatedDeviceDetails===1)?<ExpandLessOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}} /> : <ExpandMoreOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}}/>}</Button></Typography>
                    {associatedDeviceDetails===1?
                        <Box  style={{overflow:"auto"}} sx={{display:"flex",gap:'0px',flexWrap:'wrap',padding:"4px 4px 12px 4px",backgroundColor:theme==='dark'?'#3C3C3C40':'#FFFFFF80'}}>
                            <Box className="config-form-box"  sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px"}}>
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Devices</Typography>
                                {/* <CustomDropDown options={devicesList} onChange={handleAssociatedDevices} /*disabled={props.assetData.id!==""?true:false}*defaultValue={props.assetData.id!==""?props.assetData.data.associatedDevices:gatewayList[0]}></CustomDropDown>                                             */}
                                <CustomMultiselectWithCheckbox options={devicelist} selecteddata={associatedDevicesList} onChange={handleSelectedOption}/>
                                <Box sx={{display:'flex' , flexDirection:'row' ,padding:'0px 8px',alignSelf:'end',alignItems:'end'}}>
                                    {(assetInfo.data.associatedDevices.length>0)?<CustomSelectedOptions selectedOptions={associatedDevicesList} onClick={handleRemoveOption}></CustomSelectedOptions>:<></>}
                                </Box>
                            </Box>  
                        </Box>
                        :
                        <></>
                    }
                    <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "#008CD7",padding:"4px",marginTop:"20px" }}> Plant Hierarchy<Button onClick={()=>{(plantHierarchy===1)?setPlantHierarchy(0):setPlantHierarchy(1)}}>{(plantHierarchy===1)?<ExpandLessOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}} /> : <ExpandMoreOutlinedIcon style={{width: '28px', height: '28px',fontWeight: 700, color: "#008CD7",}}/>}</Button></Typography>
                    {plantHierarchy===1?
                        <Box  style={{overflow:"auto"}} sx={{display:"flex",gap:'0px',flexWrap:'wrap',padding:"4px 4px 12px 4px",backgroundColor:theme==='dark'?'#3C3C3C40':'#FFFFFF80'}}>
                            <Box className="config-form-box" sx={{padding:"4px 4px 4px 0px",width:"100%",boxSizing:'border-box',marginTop:"12px"}} >
                                <Typography  style={{ fontSize: '16px', fontWeight: 400, color: theme==='dark'?'#C1C1C1':'#3C3C3C' ,width:"224px"}}>Plant</Typography>
                                {/* <Box  style={{marginTop:0,width:'calc(100% - 224px)'}}>
                                    {payloadStructure.map((val,index) => (
                                        <>
                                            <Typography sx={{color: theme==='dark'?'#C1C1C1':'#3C3C3C',maxHeight:'250px'}} style={{whiteSpace: 'pre-line'}}>{type[0]}</Typography>
                                        </>
                                    ))}
                                </Box> */}
                            </Box>
                        </Box>
                        :
                        <></>
                    }
                </Box>
            </Box>
        )
    }

    const AssetCard = props => {
        const [anchorEl, setAnchorEl] = useState(null);
        const open = Boolean(anchorEl);
        let devicelist=[];
        props.assetlist.data.associatedDevices.map(value=>{
            deviceidlist.map(val=>{
                if(val.DeviceID===value){
                    devicelist=[...devicelist,val.Name]
                }
            })
        });
        const handleAssetCardMore = event => {
            setAnchorEl(event.currentTarget);
        };

        const handleCloseMenu = () => {
            setAnchorEl(null);
        };

        const handleAssetEdit = () => {
            const temp=props.assetlist;
            const data = {organizationId:temp.organizationId,projectId:temp.projectId,id:temp.id,data:{assetName:temp.data.assetName,serialNo:temp.data.serialNo,description:temp.data.description,/*commissionDate:temp.data.commissionDate,decommissionDate:temp.data.decommissionDate,*/associatedDevices:temp.data.associatedDevices,}}
            setAssetInfo(data);
            // setAssociatedDevicesList(temp.data.associatedDevices)
            setOpenForm(1)
        };

        function handleDeleteCheck(selected){
            if(selected===true){
                deleteAssetArr.push(assetno[props.index].id);
                setDeleteAssetArr(deleteAssetArr)
                //temp=[...temp,props.index]
            }
            else{
                setDeleteAssetArr(deleteAssetArr.filter(val => (val!==assetno[props.index].id)))
            }
        }


        useEffect(()=>{
            if(deleteAsset===2){
                // this is to be done
            }
        },[deleteAsset]);

        return (
            <Box key={props.index} sx={{display:'flex', flexDirection:'row', height:'180px',width:'394.5px',textAlign:'left',boxSizing:'border-box',overflowWrap:"break-word",}}>
                {/* <Box sx={{height:"100%", width:"1.6%",background:props.assetlist.data.enable?props.assetlist.data.connectionState?"var(--GreenBaseColor)":"var(--RedBaseColor)":"var(--GreyBaseColor)"}}></Box> */}
                <Box key={props.index} sx={{display:'flex', flexDirection:'column', height:'100%',width:'100%',background:'var(--SecondaryBackground)',padding:'10px 10px 10px 10px',textAlign:'left',boxSizing:'border-box',overflowWrap:"break-word"}}>
                    <Box  sx={{display:'flex', flexDirection:'row',width:'100%',gap:"4px"}}>
                        {deleteAsset===true?
                            <Box sx={{marginTop:'-2.58px',marginRight:'4px'}}>
                                <CustomCheckbox style={{Padding:0,}} defaultValue={false} onChange={handleDeleteCheck} width={15} height={15}/>
                            </Box>
                            :
                            <></>
                        }
                        <Typography sx={{fontFamily:'Roboto',fontSize:'20px',fontWeight:'700',color:'var(--PrimaryText)',marginTop:'-4px',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{props.assetlist.data.assetName}</Typography> 
                        <Box style={{flexGrow: 1}}></Box>
                        <Button
                            id="basic-button"
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleAssetCardMore}
                            style={{postion:"inline",height:"19px",maxWidth:"16px",minWidth:'16px',fontSize:'12px',fontWeight:'700',color:'var(--PrimaryText)',textTransform:'none',padding:0,margin:0}}
                        >
                            <MoreVertIcon sx={{height:"20px",width:"20px"}}/>
                        </Button>
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleCloseMenu}
                            MenuListProps={{
                            'aria-labelledby': 'basic-button',
                            }}
                            PaperProps={{
                                component: 'form',
                                sx:{
                                    borderRadius:0,
                                    bgcolor:theme==='dark'?'#000000':'#FFFFFF',
                                    maxHeight:'150px',
                                    maxWidth:'150px',
                                    width:"120px",
                                    height:"35px",
                                    // overflow:'scroll',
                                    color:theme==='dark'?'#C1C1C1':'#7E7E7E',
                                    padding:"0px 0px 0px 0px"
                                }
                                }}
                            style={{'::-webkit-scrollbar-track': {
                                background: '#000000'
                            }}}
                            sx={{'&.MuiList-root MuiList-padding MuiMenu-list':{ padding:"0px 0px 0px 0px"},}}
                        >
                            <MenuItem onClick={handleAssetEdit} id={props.index}>Edit</MenuItem>
                            {/* <Divider variant="middle" style={{margin:"0px 2px 0px 2px", background:theme==='dark'?'#3C3C3C':'#EFEFEF'}}/>
                            <MenuItem onClick={handleAssetDelete} id={props.index}>Delete</MenuItem> */}
                        </Menu>
                        {/* <DeviceForm /*formType={"Edit"} index={props.index} openForm={openEditForm}* closeForm={handleCloseEditForm} saveForm={handleSaveEditForm} deviceData={deviceData}/> */}
                    </Box> 
                    <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 700, color: "var(--PrimaryText)", marginRight:"24px",marginTop:"16px" }}>Associated Devices</Typography>
                    <Box  sx={{display:'flex', flexDirection:'row',width:'100%',fontSize:"16px",fontFamily:"Roboto",margin:"0px 0px 12px 0px",flexWrap:'wrap'}}>
                        {/* <Box sx={{display:'flex', flexDirection:'row',width:'50%'}}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px" }}>Total</Typography>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--PrimaryText)", marginRight:"20px" }}>00</Typography>
                        </Box>
                        <Box sx={{display:'flex', flexDirection:'row',width:'50%'}}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px" }}>Enabled</Typography>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_3)", marginRight:"20px" }}>00</Typography>
                        </Box>
                        <Box sx={{display:'flex', flexDirection:'row',width:'50%'}}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px" }}>Connected</Typography>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreenBaseColor)", marginRight:"20px" }}>00</Typography>
                        </Box>
                        <Box sx={{display:'flex', flexDirection:'row',width:'50%'}}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px" }}>Disconnected</Typography>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--RedBaseColor)", marginRight:"20px" }}>00</Typography>
                        </Box> */}
                         <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--PrimaryText)", marginRight:"20px" }}>{/*props.assetlist.data.associatedDevices.length!==0?props.assetlist.data.associatedDevices.toString()*/devicelist.length!==0?devicelist.toString():'Not Associated'}</Typography>
                         {/* <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_3)", marginRight:"20px" }}>00</Typography>
                         <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreenBaseColor)", marginRight:"20px" }}>00</Typography>
                         <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--RedBaseColor)", marginRight:"20px" }}>00</Typography> */}
                    </Box>
                    <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 700, color: "var(--PrimaryText)" }}>Asset Details</Typography>
                    <Box  sx={{display:'flex', flexDirection:'row',width:'calc(100% - 8px)',fontFamily:"Roboto",margin:"2px 0px 12px 0px",boxSizing:'border-box',gap:"16px"}}>
                        <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--PrimaryText)",lineHeight:"28px" ,width:"50%",whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Asset ID: {props.assetlist.id}</Typography>
                        <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--PrimaryText)",lineHeight:"28px" ,width:"50%",whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Serial no: {props.assetlist.data.serialNo}</Typography>
                    </Box>
                </Box>
            </Box>    
        )
    }
    
    return(
        <Box className="compliance-config" sx={{height :"100%",boxSizing:"border-box" }}>
            <Box  sx={{padding:"0px",height:'calc(100% - 0px)',width:"100%" ,boxSizing:"border-box"}} >
                <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex"}} >
                {openForm===0?
                    <>
                        <Box  sx={{display:'flex', flexDirection:'row',width:'100%',fontSize:"16px",fontFamily:"Roboto",margin:"0px",alignSelf:"center" }}>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px",alignContent:"end" }}>Total</Typography>
                            <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "var(--PrimaryText)", marginRight:"40px" }}>{assetno.length}</Typography>
                            {/* <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px",alignContent:"end" }}>Enabled</Typography>
                            <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "var(--GreyVariation_3)", marginRight:"20px" }}>{assetno.filter(assetno => assetno.data.enable === 'true').length}</Typography>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px",alignContent:"end" }}>Connected</Typography>
                            <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "var(--GreenBaseColor)", marginRight:"20px" }}>{assetno.filter(assetno => assetno.data.connectionState === 'true').length}</Typography>
                            <Typography className="config-heading" style={{ fontSize: '16px', fontWeight: 400, color: "var(--GreyVariation_4)", marginRight:"12px",alignContent:"end" }}>Disconnected</Typography>
                            <Typography className="config-heading" style={{ fontSize: '20px', fontWeight: 400, color: "var(--RedBaseColor)", marginRight:"20px" }}>{assetno.filter(assetno => assetno.data.connectionState === 'false').length}</Typography> */}
                        </Box>
                        <Box sx={{flexGrow:1,height:'24px',alignSelf:"center"}}></Box> 
                        <Button onClick={()=>setOpenForm(1)} sx={{width:'40px','& .MuiButtonBase-root.MuiButton-root':{width:'40px'},padding:0}} style={{ fontSize: '12px',height:'28px',width:'40px',fontWeight: 400,alignSelf:"center",marginLeft:"auto",marginRight:"auto",marginTop:'-8px'}}><LK_Add color='var(--LK_BrandBlue)' width={"28px"} height={"28px"}/></Button>
                        {deleteAsset!==true?
                            <Button onClick={()=>setDeleteAsset(true)} style={{ fontSize: '12px',height:'28px',width:'40px', fontWeight: 400,alignSelf:"center",marginLeft:"-20px",marginRight:"auto",marginTop:'-8px'}}><LK_Delete color='var(--LK_BrandBlue)' width={"36px"} height={"36px"}/></Button>
                            :
                            <>
                                <Button onClick={handleDeleteSelected} style={{ fontSize: '12px',height:'28px',width:'40px', fontWeight: 400,alignSelf:"center",marginLeft:"-20px",marginRight:"0",marginTop:'-8px'}}><LK_Select color='var(--LK_BrandBlue)' width={"28px"} height={"px"}/></Button>
                                <Button onClick={handleDeleteSelected} style={{ fontSize: '12px',height:'28px',width:'40px', fontWeight: 400,alignSelf:"center",marginLeft:"-20px",marginRight:"0",marginTop:'-8px'}}><LK_Delete color='var(--LK_BrandBlue)' width={"36px"} height={"36px"}/></Button>
                                <Button onClick={handleDeleteCancel} style={{ fontSize: '12px',height:'28px',width:'40px', fontWeight: 400,alignSelf:"center",marginLeft:"-20px",marginRight:"0",marginTop:'-8px'}}><LK_Close color='var(--LK_BrandBlue)' width={"24px"} height={"24px"}/></Button>
                            </>
                        }
                        {/* <Box style={{ fontSize: '12px',width:"150px",height:'20px',alignSelf:"center" }}></Box> */}
                        <Box sx={{display:'flex', flexDirection:'row',width:'30%',fontSize:"16px",fontFamily:"Roboto",margin:"-4px",alignSelf:"center" ,gap:"20px", alignItems:"center"}}>
                            <CustomTextField id={'negative-feedback'} onChange={handleSearchText} defaultValue={ifsearching===0?"":search.searchText}  placeholder={"search"} width={180}/> 
                            <CustomDropDown options={filter} onChange={handleFilterSelected} /*defaultValue={""}*/ width={"180px"}></CustomDropDown>   
                            <Button onClick={handleSearchClick} style={{ fontSize: '12px',width:"40px", fontWeight: 400, color: 'var(--Searchtext_muted)', fontFamily: 'Roboto', textAlign:'left',justifySelf:"right",cursor: 'pointer',textTransform:'none' ,marginLeft:"-24px",padding:0}}><LK_Search color='var(--LK_BrandBlue)' width={"28px"} height={"28px"}/></Button> 
                            {ifsearching===1?<Button onClick={handleSearchCancel} style={{ fontSize: '12px',width:"10px", fontWeight: 400, color: 'var(--Searchtext_muted)', fontFamily: 'Roboto', textAlign:'left',justifySelf:"right",cursor: 'pointer',textTransform:'none' ,marginLeft:"-44px",padding:0}}><LK_Close color='var(--LK_BrandBlue)' width={"24px"} height={"24px"}/></Button>:<></> }
                        </Box>
                        {/* <Button  style={{ fontSize: '12px',width:"150px",height:'20px', fontWeight: 400, color: 'var(--Searchtext_muted)', fontFamily: 'Roboto', textAlign:'left',justifySelf:"right",cursor: 'pointer',textTransform:'none' ,marginLeft:"auto",alignSelf:"center"}}>filter<Typography sx={{marginLeft:"60px"}}>v</Typography></Button>  */}
                    </>
                    :
                    <>
                        <Box sx={{display:"flex",gap:'8px',width:'100%',height:"100%"}}>
                            <Box sx={{flexGrow:1}}></Box>
                            {required===1?<><Typography sx={{color:"#DC272D"}}>required fields to must be filled</Typography></>:<></>}
                            {saveStatus!==0?
                                <>
                                    <Typography sx={{color: saveStatus===1? theme==='dark'?'#C1C1C1':'#3C3C3C':"#DC272D"}}>{saveStatus===1?"Saved Successfully!":"Save Failed"}</Typography>
                                </>
                                :
                                <></>
                            }
                            <CustomCancelButton onClick={handleCloseAddForm} buttonText={'Cancel'}></CustomCancelButton>
                            {/* <Button id={props.index} onClick={props.saveForm}>Save</Button> */}
                            <CustomButton id={assetInfo.id} onClick={handleSaveAddForm} buttonText={'Save'} width={'12px'} />
                        </Box>
                    </>
                }
                </Box>
                <Box sx={{boxSizing:"border-box",padding:"8px",background:'var(--PrimaryBackground)',height:'calc(93%)',marginBottom:"0px",overflow:"auto"}}>
                {openForm===0?
                    <>
                        <Box sx={{display:"flex",gap:'8px',flexWrap:'wrap',boxSizing:"border-box",height:'calc(100%)',overflow:"auto",alignContent:"flex-start"}} >
                            {ifsearching===0?
                                <>
                                    {assetno.map((val,index) => (
                                        <>
                                            <AssetCard index={index} assetlist={val}/>
                                        </>
                                    ))}
                                </>
                                :
                                <>
                                    {searchList.length===0?
                                        <>
                                            <Typography className="config-heading" style={{ fontSize: '40px', fontWeight: 700, color: "var(--GreyBaseColor)", marginRight:"20px" ,justifySelf:"flex-end",justifyItems:"center",justifyContent:"center",justifyTracks:"center"}}>No Match Found</Typography>
                                        </>
                                    :
                                        <>
                                            {searchList.map((val,index) => (
                                                <>
                                                    <AssetCard index={index} assetlist={val}/>
                                                </>
                                            ))}
                                        </>
                                    }
                                </>
                            }
                        </Box>
                    </>
                :
                    <Box sx={{display:"flex",gap:'8px',flexWrap:'wrap',height:'100%',boxSizing:"border-box"}} >
                        <AssetForm /*formType={"Add"} openForm={openAddForm}**/ closeForm={handleCloseAddForm}  saveForm={handleSaveAddForm}  assetData={assetInfo} />
                    </Box>
                }
                </Box>
            </Box>
        </Box>
    )
}
